import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c1562c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = { class: "flex align-items-center" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-column align"
}
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "flex flex-column p-4 row-gap-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "pt-2" }
const _hoisted_14 = { class: "pt-2" }
const _hoisted_15 = {
  class: "modal-title",
  slot: "modal-title"
}

import { computed } from '@vue/reactivity';
import { inject } from 'vue';
import { onBeforeMount } from 'vue';
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useEmitter } from '@rednex/gateway_core';
import { useI18n } from 'vue-i18n';
import { usePrimeVue } from 'primevue/config';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { watch } from 'vue';

import { detectMimeType } from '@rednex/gateway_core';

import { getGlobalProps } from '@rednex/gateway_core';
//--- Function imports

//### Service imports
import LogoService from '@/project/services/logo.service';
import PropertyService from '@/project/services/property.service';
import TranslationService from '@/locale/translation.service';
import UserManagementService from '@/admin/user-management/user-management.service';
import { AlertService } from '@rednex/gateway_core';
//--- Service imports

//### Model imports
import { languageOptions } from '@/shared/model/option-constants';
//--- Model imports

//### Component imports
import ChangePassword from '@/account/change-password/change-password-modal.vue';
import CustomSidebar from '@/core/sidebar/sidebar.vue';
import Sidebar from 'primevue/sidebar';
//--- Component imports

//### External Properties
//--- External Properties

//### Setup

export default /*#__PURE__*/_defineComponent({
  __name: 'navigation-bar',
  setup(__props) {

//### Function imports
const alertService = inject<AlertService>('alertService');
const logoService = inject<LogoService>('logoService');
const propertyService = inject<PropertyService>('propertyService');
const translationService = inject<TranslationService>('translationService');
const userManagementService = inject<UserManagementService>('userManagementService');

const globalProps = getGlobalProps();
const emitter = useEmitter();
const i18n = useI18n();
const primevue = usePrimeVue();
const router = useRouter();
const store = useStore();
//--- Setup

//### Store/Reactive Data
const applicationIsBusy = computed(() => store.getters.applicationIsBusy);
const cardTitle = computed(() => store.getters.cardTitle);
const currentLanguage = computed(() => store.getters.currentLanguage);
const driverNumber = computed(() => store.getters.driverNumber);
const isAuthenticated = computed(() => store.getters.isAuthenticated);
const isDesktopDevice = computed(() => store.getters.isDesktopDevice);
const isPhoneDevice = computed(() => store.getters.isPhoneDevice);
const languages = computed(() => store.getters.languages);
const loginName = computed(() => store.getters.currentUser?.login);
const menuExpanded = computed(() => store.getters.menuExpanded);
const themeMode = computed(() => store.getters.themeMode);
//--- Store/Reactive Data

//### Variables const let
const themeOptions = ref([
  { icon: 'fa-regular fa-moon', value: 'dark' },
  { icon: 'fa fa-lightbulb', value: 'light' },
]);

const menuUserSettings = ref();
const modalChangePasswordVisible = ref(false);

let ctxNavbar;
//--- Variables const let
const checkLastUpdate = ref(true);
const logo = ref(null);
const sidebarVisible = ref(false);
//### Component Lifecycle
onBeforeMount(() => {
  const currLanguage = Object.keys(languages.value).includes(navigator.language) ? navigator.language : currentLanguage.value;
  translationService.refreshTranslation(i18n, store, primevue, currLanguage);
  emitter.off('close-sidebar');
});

onMounted(() => {
  retrieveLogo();
  watch(
    () => {
      return store.getters.cardNavbarComponent;
    },
    cardNavbarComponent => {
      if (cardNavbarComponent) {
        ctxNavbar = cardNavbarComponent.navbarTemplate;
      }
    },
  );

  setInterval(() => {
    propertyService
      .checkLastUpdate()
      .then(res => {
        checkLastUpdate.value = res.data;
      })
      .catch(error => {
        alertService.showHttpError(globalProps, error);
      });
  }, 5000);

  emitter.on('close-sidebar', () => (sidebarVisible.value = false));
});
//--- Component Lifecycle

//### Functions
function retrieveLogo() {
  logoService
    .get(0)
    .then(res => {
      logo.value = res.data;
    })
    .catch(error => {
      alertService.showHttpError(globalProps, error);
    });
}

function changeLanguage(event: any): void {
  const newLanguage = event.value;
  const currentUser = store.getters.currentUser;
  if (currentUser) {
    currentUser.langKey = newLanguage;

    userManagementService.update(currentUser).catch(error => {
      alertService.showHttpError(globalProps, error);
    });
  }

  translationService.refreshTranslation(i18n, store, primevue, newLanguage);
}

function switchTheme(event): void {
  const { value } = event;

  if (value && themeMode.value !== value) {
    store.commit('changeTheme', themeMode.value === 'light' ? 'dark' : 'light');
  }
}

function handleLogoutClick() {
  store.commit('logout');
}

function handlePasswordChangeClick() {
  modalChangePasswordVisible.value = true;
}

function continueToDriverPage() {
  if (driverNumber.value) {
    router.push('/mylaptimeslist');
  }
}

const toggleUserMenu = event => {
  menuUserSettings.value.toggle(event);
};

//--- Functions

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(checkLastUpdate.value === true ? 'menu-container' : 'menu-container no-update')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Button, {
          class: "navbar-button",
          icon: "fa fa-bars",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarVisible.value = !sidebarVisible.value))
        }),
        _createVNode(_unref(Sidebar), {
          style: {"margin-top":"100px","width":"13rem"},
          showCloseIcon: false,
          visible: sidebarVisible.value
        }, {
          default: _withCtx(() => [
            _createVNode(CustomSidebar)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["visible"]),
        (logo.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              style: {"margin-left":"20px"},
              class: "headerlogo",
              src: 'data:image' + _unref(detectMimeType)(logo.value) + ';base64,' + logo.value
            }, null, 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          style: {"margin-left":"5px","height":"40px"},
          class: "w-full",
          onClick: continueToDriverPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("#" + _toDisplayString(_unref(driverNumber)), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createCommentVNode("        <SelectButton class=\"mr-1\" v-model=\"themeMode\" @change=\"switchTheme\" :options=\"themeOptions\" optionValue=\"value\">"),
        _createCommentVNode("          <template #option=\"slotProps\">"),
        _createCommentVNode("            <i :class=\"slotProps.option.icon\"></i>"),
        _createCommentVNode("          </template>"),
        _createCommentVNode("        </SelectButton>"),
        _createCommentVNode("        <SelectButton"),
        _createCommentVNode("          class=\"mr-1\""),
        _createCommentVNode("          v-model=\"currentLanguage\""),
        _createCommentVNode("          @change=\"changeLanguage\""),
        _createCommentVNode("          :options=\"languageOptions\""),
        _createCommentVNode("          optionLabel=\"label\""),
        _createCommentVNode("          optionValue=\"value\""),
        _createCommentVNode("        >"),
        _createCommentVNode("          <template #option=\"slotProps\">"),
        _createCommentVNode("            {{ slotProps.option.label }}"),
        _createCommentVNode("          </template>"),
        _createCommentVNode("        </SelectButton>"),
        (_unref(isAuthenticated))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: toggleUserMenu,
              class: "p-link flex align-items-center p-2 mr-4 text-color"
            }, [
              (_unref(isDesktopDevice))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(loginName)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Menu, {
          ref_key: "menuUserSettings",
          ref: menuUserSettings,
          id: "overlay_layout_menu",
          class: "mt-2",
          popup: true
        }, {
          start: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              (!_unref(isDesktopDevice))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(loginName)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_Button, {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (handlePasswordChangeClick())),
                  label: _ctx.$t('menu.account.changePassword'),
                  class: "p-button-text",
                  icon: "fa fa-key",
                  style: {"padding":"0"},
                  type: "button"
                }, null, 8 /* PROPS */, ["label"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handleLogoutClick())),
                  label: _ctx.$t('menu.logout'),
                  class: "p-button-text",
                  icon: "fa fa-arrow-right-from-bracket",
                  style: {"padding":"0"},
                  type: "button"
                }, null, 8 /* PROPS */, ["label"])
              ])
            ])
          ]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
      ])
    ]),
    _createCommentVNode(" eslint-disable vue/no-v-model-argument "),
    _createVNode(_component_Dialog, {
      visible: modalChangePasswordVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((modalChangePasswordVisible).value = $event)),
      contentClass: 'default-dialog',
      draggable: false,
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t('menu.account.changePassword')), 1 /* TEXT */)
      ]),
      default: _withCtx(() => [
        _createVNode(ChangePassword)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ], 2 /* CLASS */))
}
}

})